/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAzure extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForAzure");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForAzure.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAzure>): CostProcessingMemoryForAzure {
        let obj = Object.assign(new CostProcessingMemoryForAzure(), model);
        CostProcessingMemoryForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAzure>): CostProcessingMemoryForAzure {
        if (!model) return null;
        return CostProcessingMemoryForAzure.newInstance(<CostProcessingMemoryForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAzure) {
        if (!obj) return;

        models.CostProcessingMemoryForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAzure): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.CostProcessingPeriodMemoryForAzure.fixupPrototype(val);
            }
        }
        if (this.pending_reports) {
            for (let val of this.pending_reports) {
                models.CostProcessingMemoryForAzurePendingPeriod.fixupPrototype(val);
            }
        }
    }

    /**
     * Processed billing periods
     */
    periods: Array<models.CostProcessingPeriodMemoryForAzure>;

    /**
     * Requested Billing reports
     */
    pending_reports: Array<models.CostProcessingMemoryForAzurePendingPeriod>;

}
